import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames/bind';
import styles from './index.module.pcss';
import properties from '../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
interface LoaderProps {
  url?: string;
  usePortal?: boolean;
}
const Loader = ({ url, usePortal = false }: LoaderProps): JSX.Element => {
  const cx = classNames.bind(styles);
  const gif = (
    <img className={cx('imgClass')} alt="Ajio loader" src={replaceWithJioCDN(url)} />
  );
  const overlay = <div className={cx('loader')}>{gif}</div>;
  if (usePortal && typeof document !== 'undefined') {
    return createPortal(overlay, document.body);
  }
  return overlay;
};
Loader.defaultProps = {
  url: `${imageBaseUrl}/static/img/refreshsitespinner_2.gif`,
  usePortal: false
};
export default Loader;
